import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash'
import {reduxForm, formValueSelector} from 'redux-form'
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Datetime from '../../../../../uis/form/datetime';
import Select from '../../../../../uis/form/select'
import dateFormat from '../../../../../util/dateFormat'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }
})

const validate = values => {
    const errors = {}
    
    if (!values.aliwangwang) {
        errors.aliwangwang = '必填'
    }

    if (!values.reason) {
        errors.reason = '必填'
    }
    
    if (!values.phone) {
        errors.phone = '必填'
    }
    
    // if (!values.email) {
    //     errors.email = '必填'
    // } else if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(values.email)) {
    //     errors.email = '格式不正确';
    // }
    return errors
}

class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, reason, change} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <Text name="aliwangwang" label="旺旺号" placeholder="请输入旺旺号" className={classes.textField} required={true}/>
                    
                    <Text name="phone" label="电话" placeholder="请输入电话" className={classes.textField} required={true}/>
                    
                    <Select name="reason" label="原因" placeholder="请输入原因" className={classes.textField} required={true} onChange={(e)=>change('applyTime', ['未发货退款', '已发货退款'].includes(e.target.value) ? dateFormat(new Date(), 'yyyy-MM-dd') : null)} data={[{"name":"云黑名单","value":"云黑名单"},{"name":"旺旺威胁退款","value":"旺旺威胁退款"},{"name":"未发货退款","value":"未发货退款"},{"name":"已发货退款","value":"已发货退款"},{"name":"差评","value":"差评"},{"name":"其他","value":"其他"}]}/>
                    
                    {['未发货退款', '已发货退款'].includes(reason) && <Datetime name="applyTime" label="退款时间" placeholder="请输入退款时间" className={classes.textField} required={false}/>}
                    {['其他'].includes(reason) && <Text name="reasonText" label="其他原因" placeholder="请输入其他原因" className={classes.textField} required={false}/>}
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, reason, change} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <Text name="aliwangwang" label="旺旺号" placeholder="请输入旺旺号" className={classes.textField} required={true}/>
                    
                    <Text name="phone" label="电话" placeholder="请输入电话" className={classes.textField} required={true}/>
                    
                    <Select name="reason" label="原因" placeholder="请输入原因" className={classes.textField} required={true} onChange={(e)=>change('applyTime', ['未发货退款', '已发货退款'].includes(e.target.value) ? dateFormat(new Date(), 'yyyy-MM-dd') : null)} data={[{"name":"云黑名单","value":"云黑名单"},{"name":"旺旺威胁退款","value":"旺旺威胁退款"},{"name":"未发货退款","value":"未发货退款"},{"name":"已发货退款","value":"已发货退款"},{"name":"差评","value":"差评"},{"name":"其他","value":"其他"}]}/>
                    
                    {['未发货退款', '已发货退款'].includes(reason) && <Datetime name="applyTime" label="退款时间" placeholder="请输入退款时间" className={classes.textField} required={false}/>}
                    {['其他'].includes(reason) && <Text name="reasonText" label="其他原因" placeholder="请输入其他原因" className={classes.textField} required={false}/>}
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        const selector = formValueSelector('blacklistAddForm')
        return {
            reason: selector(state, 'reason')
        }
    },
)(reduxForm({
    form: 'blacklistAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => {
        const selector = formValueSelector('blacklistUpdateForm')
        return {
            initialValues: state.blacklist.detail,
            reason: selector(state, 'reason')
        }
    },
  )(reduxForm({
    form: 'blacklistUpdateForm'
})(UpdateDialog))

class Blacklist extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['黑名单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>录入信息</TableCell>

                                <TableCell>旺旺号</TableCell>
                                
                                <TableCell>电话</TableCell>
                                
                                <TableCell>原因</TableCell>
                                
                                {(permissionMap['黑名单_修改'] || permissionMap['黑名单_删除']) && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <p>ID: {row.id}</p>
                                            <p>创建时间: {dateFormat(new Date(row.createTime))}</p>
                                            <p>创建人: {row.accountName}</p>
                                        </TableCell>
                                        
                                        <TableCell>{row.aliwangwang}</TableCell>
                                        
                                        <TableCell>{row.phone}</TableCell>
                                        
                                        <TableCell>
                                            <p>原因: {row.reason}</p>
                                            {['未发货退款', '已发货退款'].includes(row.reason) && <p>退款时间: {dateFormat(new Date(row.applyTime))}</p>}
                                            {['其他'].includes(row.reason) && <p>其他原因: {row.reasonText}</p>}
                                        </TableCell>
                                        
                                        {(permissionMap['黑名单_修改'] || permissionMap['黑名单_删除']) && <TableCell>
                                            {permissionMap['黑名单_修改'] && <Tooltip title="修改">
                                                <IconButton color="primary" onClick={()=>dispatch(actions.showUpdateModal(row.id))}><ModeEditIcon /></IconButton>
                                            </Tooltip>}
                                            {permissionMap['黑名单_删除'] && <Tooltip title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.blacklist,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Blacklist))


// WEBPACK FOOTER //
// ./src/pages/home/routes/blacklist/components/list.js